import require$$0$1, { createContext, Component, createElement, useState, useEffect, lazy, Suspense, memo, forwardRef } from 'react';
import require$$0 from 'react-dom';

var createRoot;

var m = require$$0;
if (process.env.NODE_ENV === 'production') {
  createRoot = m.createRoot;
  m.hydrateRoot;
} else {
  var i = m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  createRoot = function(c, o) {
    i.usingClientEntryPoint = true;
    try {
      return m.createRoot(c, o);
    } finally {
      i.usingClientEntryPoint = false;
    }
  };
}

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min () {
	if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
	hasRequiredReactJsxRuntime_production_min = 1;
var f=require$$0$1,k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
	function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}reactJsxRuntime_production_min.Fragment=l;reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;
	return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development () {
	if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
	hasRequiredReactJsxRuntime_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	var React = require$$0$1;

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types.
	var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	var REACT_MEMO_TYPE = Symbol.for('react.memo');
	var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
	var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator';
	function getIteratorFn(maybeIterable) {
	  if (maybeIterable === null || typeof maybeIterable !== 'object') {
	    return null;
	  }

	  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

	  if (typeof maybeIterator === 'function') {
	    return maybeIterator;
	  }

	  return null;
	}

	var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

	function error(format) {
	  {
	    {
	      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }

	      printWarning('error', format, args);
	    }
	  }
	}

	function printWarning(level, format, args) {
	  // When changing this logic, you might want to also
	  // update consoleWithStackDev.www.js as well.
	  {
	    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	    var stack = ReactDebugCurrentFrame.getStackAddendum();

	    if (stack !== '') {
	      format += '%s';
	      args = args.concat([stack]);
	    } // eslint-disable-next-line react-internal/safe-string-coercion


	    var argsWithFormat = args.map(function (item) {
	      return String(item);
	    }); // Careful: RN currently depends on this prefix

	    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
	    // breaks IE9: https://github.com/facebook/react/issues/13610
	    // eslint-disable-next-line react-internal/no-production-logging

	    Function.prototype.apply.call(console[level], console, argsWithFormat);
	  }
	}

	// -----------------------------------------------------------------------------

	var enableScopeAPI = false; // Experimental Create Event Handle API.
	var enableCacheElement = false;
	var enableTransitionTracing = false; // No known bugs, but needs performance testing

	var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
	// stuff. Intended to enable React core members to more easily debug scheduling
	// issues in DEV builds.

	var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

	var REACT_MODULE_REFERENCE;

	{
	  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
	}

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
	    // types supported by any Flight configuration anywhere since
	    // we don't know which Flight build this will end up being used
	    // with.
	    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
	      return true;
	    }
	  }

	  return false;
	}

	function getWrappedName(outerType, innerType, wrapperName) {
	  var displayName = outerType.displayName;

	  if (displayName) {
	    return displayName;
	  }

	  var functionName = innerType.displayName || innerType.name || '';
	  return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
	} // Keep in sync with react-reconciler/getComponentNameFromFiber


	function getContextName(type) {
	  return type.displayName || 'Context';
	} // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.


	function getComponentNameFromType(type) {
	  if (type == null) {
	    // Host root, text node or just invalid type.
	    return null;
	  }

	  {
	    if (typeof type.tag === 'number') {
	      error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
	    }
	  }

	  if (typeof type === 'function') {
	    return type.displayName || type.name || null;
	  }

	  if (typeof type === 'string') {
	    return type;
	  }

	  switch (type) {
	    case REACT_FRAGMENT_TYPE:
	      return 'Fragment';

	    case REACT_PORTAL_TYPE:
	      return 'Portal';

	    case REACT_PROFILER_TYPE:
	      return 'Profiler';

	    case REACT_STRICT_MODE_TYPE:
	      return 'StrictMode';

	    case REACT_SUSPENSE_TYPE:
	      return 'Suspense';

	    case REACT_SUSPENSE_LIST_TYPE:
	      return 'SuspenseList';

	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_CONTEXT_TYPE:
	        var context = type;
	        return getContextName(context) + '.Consumer';

	      case REACT_PROVIDER_TYPE:
	        var provider = type;
	        return getContextName(provider._context) + '.Provider';

	      case REACT_FORWARD_REF_TYPE:
	        return getWrappedName(type, type.render, 'ForwardRef');

	      case REACT_MEMO_TYPE:
	        var outerName = type.displayName || null;

	        if (outerName !== null) {
	          return outerName;
	        }

	        return getComponentNameFromType(type.type) || 'Memo';

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            return getComponentNameFromType(init(payload));
	          } catch (x) {
	            return null;
	          }
	        }

	      // eslint-disable-next-line no-fallthrough
	    }
	  }

	  return null;
	}

	var assign = Object.assign;

	// Helpers to patch console.logs to avoid logging during side-effect free
	// replaying on render function. This currently only patches the object
	// lazily which won't cover if the log function was extracted eagerly.
	// We could also eagerly patch the method.
	var disabledDepth = 0;
	var prevLog;
	var prevInfo;
	var prevWarn;
	var prevError;
	var prevGroup;
	var prevGroupCollapsed;
	var prevGroupEnd;

	function disabledLog() {}

	disabledLog.__reactDisabledLog = true;
	function disableLogs() {
	  {
	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      prevLog = console.log;
	      prevInfo = console.info;
	      prevWarn = console.warn;
	      prevError = console.error;
	      prevGroup = console.group;
	      prevGroupCollapsed = console.groupCollapsed;
	      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

	      var props = {
	        configurable: true,
	        enumerable: true,
	        value: disabledLog,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        info: props,
	        log: props,
	        warn: props,
	        error: props,
	        group: props,
	        groupCollapsed: props,
	        groupEnd: props
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    disabledDepth++;
	  }
	}
	function reenableLogs() {
	  {
	    disabledDepth--;

	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      var props = {
	        configurable: true,
	        enumerable: true,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        log: assign({}, props, {
	          value: prevLog
	        }),
	        info: assign({}, props, {
	          value: prevInfo
	        }),
	        warn: assign({}, props, {
	          value: prevWarn
	        }),
	        error: assign({}, props, {
	          value: prevError
	        }),
	        group: assign({}, props, {
	          value: prevGroup
	        }),
	        groupCollapsed: assign({}, props, {
	          value: prevGroupCollapsed
	        }),
	        groupEnd: assign({}, props, {
	          value: prevGroupEnd
	        })
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    if (disabledDepth < 0) {
	      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
	    }
	  }
	}

	var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
	var prefix;
	function describeBuiltInComponentFrame(name, source, ownerFn) {
	  {
	    if (prefix === undefined) {
	      // Extract the VM specific prefix used by each line.
	      try {
	        throw Error();
	      } catch (x) {
	        var match = x.stack.trim().match(/\n( *(at )?)/);
	        prefix = match && match[1] || '';
	      }
	    } // We use the prefix to ensure our stacks line up with native stack frames.


	    return '\n' + prefix + name;
	  }
	}
	var reentry = false;
	var componentFrameCache;

	{
	  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
	  componentFrameCache = new PossiblyWeakMap();
	}

	function describeNativeComponentFrame(fn, construct) {
	  // If something asked for a stack inside a fake render, it should get ignored.
	  if ( !fn || reentry) {
	    return '';
	  }

	  {
	    var frame = componentFrameCache.get(fn);

	    if (frame !== undefined) {
	      return frame;
	    }
	  }

	  var control;
	  reentry = true;
	  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

	  Error.prepareStackTrace = undefined;
	  var previousDispatcher;

	  {
	    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
	    // for warnings.

	    ReactCurrentDispatcher.current = null;
	    disableLogs();
	  }

	  try {
	    // This should throw.
	    if (construct) {
	      // Something should be setting the props in the constructor.
	      var Fake = function () {
	        throw Error();
	      }; // $FlowFixMe


	      Object.defineProperty(Fake.prototype, 'props', {
	        set: function () {
	          // We use a throwing setter instead of frozen or non-writable props
	          // because that won't throw in a non-strict mode function.
	          throw Error();
	        }
	      });

	      if (typeof Reflect === 'object' && Reflect.construct) {
	        // We construct a different control for this case to include any extra
	        // frames added by the construct call.
	        try {
	          Reflect.construct(Fake, []);
	        } catch (x) {
	          control = x;
	        }

	        Reflect.construct(fn, [], Fake);
	      } else {
	        try {
	          Fake.call();
	        } catch (x) {
	          control = x;
	        }

	        fn.call(Fake.prototype);
	      }
	    } else {
	      try {
	        throw Error();
	      } catch (x) {
	        control = x;
	      }

	      fn();
	    }
	  } catch (sample) {
	    // This is inlined manually because closure doesn't do it for us.
	    if (sample && control && typeof sample.stack === 'string') {
	      // This extracts the first frame from the sample that isn't also in the control.
	      // Skipping one frame that we assume is the frame that calls the two.
	      var sampleLines = sample.stack.split('\n');
	      var controlLines = control.stack.split('\n');
	      var s = sampleLines.length - 1;
	      var c = controlLines.length - 1;

	      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
	        // We expect at least one stack frame to be shared.
	        // Typically this will be the root most one. However, stack frames may be
	        // cut off due to maximum stack limits. In this case, one maybe cut off
	        // earlier than the other. We assume that the sample is longer or the same
	        // and there for cut off earlier. So we should find the root most frame in
	        // the sample somewhere in the control.
	        c--;
	      }

	      for (; s >= 1 && c >= 0; s--, c--) {
	        // Next we find the first one that isn't the same which should be the
	        // frame that called our sample function and the control.
	        if (sampleLines[s] !== controlLines[c]) {
	          // In V8, the first line is describing the message but other VMs don't.
	          // If we're about to return the first line, and the control is also on the same
	          // line, that's a pretty good indicator that our sample threw at same line as
	          // the control. I.e. before we entered the sample frame. So we ignore this result.
	          // This can happen if you passed a class to function component, or non-function.
	          if (s !== 1 || c !== 1) {
	            do {
	              s--;
	              c--; // We may still have similar intermediate frames from the construct call.
	              // The next one that isn't the same should be our match though.

	              if (c < 0 || sampleLines[s] !== controlLines[c]) {
	                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
	                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
	                // but we have a user-provided "displayName"
	                // splice it in to make the stack more readable.


	                if (fn.displayName && _frame.includes('<anonymous>')) {
	                  _frame = _frame.replace('<anonymous>', fn.displayName);
	                }

	                {
	                  if (typeof fn === 'function') {
	                    componentFrameCache.set(fn, _frame);
	                  }
	                } // Return the line we found.


	                return _frame;
	              }
	            } while (s >= 1 && c >= 0);
	          }

	          break;
	        }
	      }
	    }
	  } finally {
	    reentry = false;

	    {
	      ReactCurrentDispatcher.current = previousDispatcher;
	      reenableLogs();
	    }

	    Error.prepareStackTrace = previousPrepareStackTrace;
	  } // Fallback to just using the name if we couldn't make it throw.


	  var name = fn ? fn.displayName || fn.name : '';
	  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

	  {
	    if (typeof fn === 'function') {
	      componentFrameCache.set(fn, syntheticFrame);
	    }
	  }

	  return syntheticFrame;
	}
	function describeFunctionComponentFrame(fn, source, ownerFn) {
	  {
	    return describeNativeComponentFrame(fn, false);
	  }
	}

	function shouldConstruct(Component) {
	  var prototype = Component.prototype;
	  return !!(prototype && prototype.isReactComponent);
	}

	function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

	  if (type == null) {
	    return '';
	  }

	  if (typeof type === 'function') {
	    {
	      return describeNativeComponentFrame(type, shouldConstruct(type));
	    }
	  }

	  if (typeof type === 'string') {
	    return describeBuiltInComponentFrame(type);
	  }

	  switch (type) {
	    case REACT_SUSPENSE_TYPE:
	      return describeBuiltInComponentFrame('Suspense');

	    case REACT_SUSPENSE_LIST_TYPE:
	      return describeBuiltInComponentFrame('SuspenseList');
	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_FORWARD_REF_TYPE:
	        return describeFunctionComponentFrame(type.render);

	      case REACT_MEMO_TYPE:
	        // Memo may contain any component type so we recursively resolve it.
	        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            // Lazy may contain any component type so we recursively resolve it.
	            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
	          } catch (x) {}
	        }
	    }
	  }

	  return '';
	}

	var hasOwnProperty = Object.prototype.hasOwnProperty;

	var loggedTypeFailures = {};
	var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame.setExtraStackFrame(null);
	    }
	  }
	}

	function checkPropTypes(typeSpecs, values, location, componentName, element) {
	  {
	    // $FlowFixMe This is okay but Flow doesn't know it.
	    var has = Function.call.bind(hasOwnProperty);

	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.

	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            // eslint-disable-next-line react-internal/prod-error-codes
	            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
	            err.name = 'Invariant Violation';
	            throw err;
	          }

	          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        } catch (ex) {
	          error$1 = ex;
	        }

	        if (error$1 && !(error$1 instanceof Error)) {
	          setCurrentlyValidatingElement(element);

	          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

	          setCurrentlyValidatingElement(null);
	        }

	        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error$1.message] = true;
	          setCurrentlyValidatingElement(element);

	          error('Failed %s type: %s', location, error$1.message);

	          setCurrentlyValidatingElement(null);
	        }
	      }
	    }
	  }
	}

	var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

	function isArray(a) {
	  return isArrayImpl(a);
	}

	/*
	 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
	 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
	 *
	 * The functions in this module will throw an easier-to-understand,
	 * easier-to-debug exception with a clear errors message message explaining the
	 * problem. (Instead of a confusing exception thrown inside the implementation
	 * of the `value` object).
	 */
	// $FlowFixMe only called in DEV, so void return is not possible.
	function typeName(value) {
	  {
	    // toStringTag is needed for namespaced types like Temporal.Instant
	    var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
	    var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
	    return type;
	  }
	} // $FlowFixMe only called in DEV, so void return is not possible.


	function willCoercionThrow(value) {
	  {
	    try {
	      testStringCoercion(value);
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	}

	function testStringCoercion(value) {
	  // If you ended up here by following an exception call stack, here's what's
	  // happened: you supplied an object or symbol value to React (as a prop, key,
	  // DOM attribute, CSS property, string ref, etc.) and when React tried to
	  // coerce it to a string using `'' + value`, an exception was thrown.
	  //
	  // The most common types that will cause this exception are `Symbol` instances
	  // and Temporal objects like `Temporal.Instant`. But any object that has a
	  // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
	  // exception. (Library authors do this to prevent users from using built-in
	  // numeric operators like `+` or comparison operators like `>=` because custom
	  // methods are needed to perform accurate arithmetic or comparison.)
	  //
	  // To fix the problem, coerce this object or symbol value to a string before
	  // passing it to React. The most reliable way is usually `String(value)`.
	  //
	  // To find which value is throwing, check the browser or debugger console.
	  // Before this exception was thrown, there should be `console.error` output
	  // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
	  // problem and how that type was used: key, atrribute, input value prop, etc.
	  // In most cases, this console output also shows the component and its
	  // ancestor components where the exception happened.
	  //
	  // eslint-disable-next-line react-internal/safe-string-coercion
	  return '' + value;
	}
	function checkKeyStringCoercion(value) {
	  {
	    if (willCoercionThrow(value)) {
	      error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));

	      return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
	    }
	  }
	}

	var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	var specialPropKeyWarningShown;
	var specialPropRefWarningShown;
	var didWarnAboutStringRefs;

	{
	  didWarnAboutStringRefs = {};
	}

	function hasValidRef(config) {
	  {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.ref !== undefined;
	}

	function hasValidKey(config) {
	  {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.key !== undefined;
	}

	function warnIfStringRefCannotBeAutoConverted(config, self) {
	  {
	    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
	      var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);

	      if (!didWarnAboutStringRefs[componentName]) {
	        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);

	        didWarnAboutStringRefs[componentName] = true;
	      }
	    }
	  }
	}

	function defineKeyPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingKey = function () {
	      if (!specialPropKeyWarningShown) {
	        specialPropKeyWarningShown = true;

	        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingKey.isReactWarning = true;
	    Object.defineProperty(props, 'key', {
	      get: warnAboutAccessingKey,
	      configurable: true
	    });
	  }
	}

	function defineRefPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingRef = function () {
	      if (!specialPropRefWarningShown) {
	        specialPropRefWarningShown = true;

	        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingRef.isReactWarning = true;
	    Object.defineProperty(props, 'ref', {
	      get: warnAboutAccessingRef,
	      configurable: true
	    });
	  }
	}
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, instanceof check
	 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} props
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} owner
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @internal
	 */


	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allows us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };

	  {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.

	    Object.defineProperty(element._store, 'validated', {
	      configurable: false,
	      enumerable: false,
	      writable: true,
	      value: false
	    }); // self and source are DEV only properties.

	    Object.defineProperty(element, '_self', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: self
	    }); // Two elements created in two different places should be considered
	    // equal for testing purposes and therefore we hide it from enumeration.

	    Object.defineProperty(element, '_source', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: source
	    });

	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }

	  return element;
	};
	/**
	 * https://github.com/reactjs/rfcs/pull/107
	 * @param {*} type
	 * @param {object} props
	 * @param {string} key
	 */

	function jsxDEV(type, config, maybeKey, source, self) {
	  {
	    var propName; // Reserved names are extracted

	    var props = {};
	    var key = null;
	    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
	    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
	    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
	    // but as an intermediary step, we will use jsxDEV for everything except
	    // <div {...props} key="Hi" />, because we aren't currently able to tell if
	    // key is explicitly declared to be undefined or not.

	    if (maybeKey !== undefined) {
	      {
	        checkKeyStringCoercion(maybeKey);
	      }

	      key = '' + maybeKey;
	    }

	    if (hasValidKey(config)) {
	      {
	        checkKeyStringCoercion(config.key);
	      }

	      key = '' + config.key;
	    }

	    if (hasValidRef(config)) {
	      ref = config.ref;
	      warnIfStringRefCannotBeAutoConverted(config, self);
	    } // Remaining properties are added to a new props object


	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    } // Resolve default props


	    if (type && type.defaultProps) {
	      var defaultProps = type.defaultProps;

	      for (propName in defaultProps) {
	        if (props[propName] === undefined) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    }

	    if (key || ref) {
	      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

	      if (key) {
	        defineKeyPropWarningGetter(props, displayName);
	      }

	      if (ref) {
	        defineRefPropWarningGetter(props, displayName);
	      }
	    }

	    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	  }
	}

	var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
	var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement$1(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
	    }
	  }
	}

	var propTypesMisspellWarningShown;

	{
	  propTypesMisspellWarningShown = false;
	}
	/**
	 * Verifies the object is a ReactElement.
	 * See https://reactjs.org/docs/react-api.html#isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a ReactElement.
	 * @final
	 */


	function isValidElement(object) {
	  {
	    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	  }
	}

	function getDeclarationErrorAddendum() {
	  {
	    if (ReactCurrentOwner$1.current) {
	      var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);

	      if (name) {
	        return '\n\nCheck the render method of `' + name + '`.';
	      }
	    }

	    return '';
	  }
	}

	function getSourceInfoErrorAddendum(source) {
	  {

	    return '';
	  }
	}
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */


	var ownerHasKeyUseWarning = {};

	function getCurrentComponentErrorInfo(parentType) {
	  {
	    var info = getDeclarationErrorAddendum();

	    if (!info) {
	      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

	      if (parentName) {
	        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
	      }
	    }

	    return info;
	  }
	}
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it. Error statuses are cached so a warning
	 * will only be shown once.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */


	function validateExplicitKey(element, parentType) {
	  {
	    if (!element._store || element._store.validated || element.key != null) {
	      return;
	    }

	    element._store.validated = true;
	    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

	    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
	      return;
	    }

	    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
	    // property, it may be the creator of the child that's responsible for
	    // assigning it a key.

	    var childOwner = '';

	    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
	      // Give the component that originally created this child.
	      childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
	    }

	    setCurrentlyValidatingElement$1(element);

	    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

	    setCurrentlyValidatingElement$1(null);
	  }
	}
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */


	function validateChildKeys(node, parentType) {
	  {
	    if (typeof node !== 'object') {
	      return;
	    }

	    if (isArray(node)) {
	      for (var i = 0; i < node.length; i++) {
	        var child = node[i];

	        if (isValidElement(child)) {
	          validateExplicitKey(child, parentType);
	        }
	      }
	    } else if (isValidElement(node)) {
	      // This element was passed in a valid location.
	      if (node._store) {
	        node._store.validated = true;
	      }
	    } else if (node) {
	      var iteratorFn = getIteratorFn(node);

	      if (typeof iteratorFn === 'function') {
	        // Entry iterators used to provide implicit keys,
	        // but now we print a separate warning for them later.
	        if (iteratorFn !== node.entries) {
	          var iterator = iteratorFn.call(node);
	          var step;

	          while (!(step = iterator.next()).done) {
	            if (isValidElement(step.value)) {
	              validateExplicitKey(step.value, parentType);
	            }
	          }
	        }
	      }
	    }
	  }
	}
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */


	function validatePropTypes(element) {
	  {
	    var type = element.type;

	    if (type === null || type === undefined || typeof type === 'string') {
	      return;
	    }

	    var propTypes;

	    if (typeof type === 'function') {
	      propTypes = type.propTypes;
	    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
	    // Inner props are checked in the reconciler.
	    type.$$typeof === REACT_MEMO_TYPE)) {
	      propTypes = type.propTypes;
	    } else {
	      return;
	    }

	    if (propTypes) {
	      // Intentionally inside to avoid triggering lazy initializers:
	      var name = getComponentNameFromType(type);
	      checkPropTypes(propTypes, element.props, 'prop', name, element);
	    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
	      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

	      var _name = getComponentNameFromType(type);

	      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
	    }

	    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
	      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
	    }
	  }
	}
	/**
	 * Given a fragment, validate that it can only be provided with fragment props
	 * @param {ReactElement} fragment
	 */


	function validateFragmentProps(fragment) {
	  {
	    var keys = Object.keys(fragment.props);

	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];

	      if (key !== 'children' && key !== 'key') {
	        setCurrentlyValidatingElement$1(fragment);

	        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

	        setCurrentlyValidatingElement$1(null);
	        break;
	      }
	    }

	    if (fragment.ref !== null) {
	      setCurrentlyValidatingElement$1(fragment);

	      error('Invalid attribute `ref` supplied to `React.Fragment`.');

	      setCurrentlyValidatingElement$1(null);
	    }
	  }
	}

	var didWarnAboutKeySpread = {};
	function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
	  {
	    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.

	    if (!validType) {
	      var info = '';

	      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
	      }

	      var sourceInfo = getSourceInfoErrorAddendum();

	      if (sourceInfo) {
	        info += sourceInfo;
	      } else {
	        info += getDeclarationErrorAddendum();
	      }

	      var typeString;

	      if (type === null) {
	        typeString = 'null';
	      } else if (isArray(type)) {
	        typeString = 'array';
	      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
	        typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
	        info = ' Did you accidentally export a JSX literal instead of a component?';
	      } else {
	        typeString = typeof type;
	      }

	      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
	    }

	    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.

	    if (element == null) {
	      return element;
	    } // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)


	    if (validType) {
	      var children = props.children;

	      if (children !== undefined) {
	        if (isStaticChildren) {
	          if (isArray(children)) {
	            for (var i = 0; i < children.length; i++) {
	              validateChildKeys(children[i], type);
	            }

	            if (Object.freeze) {
	              Object.freeze(children);
	            }
	          } else {
	            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
	          }
	        } else {
	          validateChildKeys(children, type);
	        }
	      }
	    }

	    {
	      if (hasOwnProperty.call(props, 'key')) {
	        var componentName = getComponentNameFromType(type);
	        var keys = Object.keys(props).filter(function (k) {
	          return k !== 'key';
	        });
	        var beforeExample = keys.length > 0 ? '{key: someKey, ' + keys.join(': ..., ') + ': ...}' : '{key: someKey}';

	        if (!didWarnAboutKeySpread[componentName + beforeExample]) {
	          var afterExample = keys.length > 0 ? '{' + keys.join(': ..., ') + ': ...}' : '{}';

	          error('A props object containing a "key" prop is being spread into JSX:\n' + '  let props = %s;\n' + '  <%s {...props} />\n' + 'React keys must be passed directly to JSX without using spread:\n' + '  let props = %s;\n' + '  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);

	          didWarnAboutKeySpread[componentName + beforeExample] = true;
	        }
	      }
	    }

	    if (type === REACT_FRAGMENT_TYPE) {
	      validateFragmentProps(element);
	    } else {
	      validatePropTypes(element);
	    }

	    return element;
	  }
	} // These two functions exist to still get child warnings in dev
	// even with the prod transform. This means that jsxDEV is purely
	// opt-in behavior for better messages but that we won't stop
	// giving you warnings if you use production apis.

	function jsxWithValidationStatic(type, props, key) {
	  {
	    return jsxWithValidation(type, props, key, true);
	  }
	}
	function jsxWithValidationDynamic(type, props, key) {
	  {
	    return jsxWithValidation(type, props, key, false);
	  }
	}

	var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
	// for now we can ship identical prod functions

	var jsxs =  jsxWithValidationStatic ;

	reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
	reactJsxRuntime_development.jsx = jsx;
	reactJsxRuntime_development.jsxs = jsxs;
	  })();
	}
	return reactJsxRuntime_development;
}

if (process.env.NODE_ENV === 'production') {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}

var jsxRuntimeExports = jsxRuntime.exports;

const ErrorBoundaryContext = createContext(null);

const initialState = {
  didCatch: false,
  error: null
};
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
    this.state = initialState;
  }
  static getDerivedStateFromError(error) {
    return {
      didCatch: true,
      error
    };
  }
  resetErrorBoundary() {
    const {
      error
    } = this.state;
    if (error !== null) {
      var _this$props$onReset, _this$props;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 ? void 0 : _this$props$onReset.call(_this$props, {
        args,
        reason: "imperative-api"
      });
      this.setState(initialState);
    }
  }
  componentDidCatch(error, info) {
    var _this$props$onError, _this$props2;
    (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props2, error, info);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      didCatch
    } = this.state;
    const {
      resetKeys
    } = this.props;

    // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
    // we'd end up resetting the error boundary immediately.
    // This would likely trigger a second error to be thrown.
    // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.

    if (didCatch && prevState.error !== null && hasArrayChanged(prevProps.resetKeys, resetKeys)) {
      var _this$props$onReset2, _this$props3;
      (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 ? void 0 : _this$props$onReset2.call(_this$props3, {
        next: resetKeys,
        prev: prevProps.resetKeys,
        reason: "keys"
      });
      this.setState(initialState);
    }
  }
  render() {
    const {
      children,
      fallbackRender,
      FallbackComponent,
      fallback
    } = this.props;
    const {
      didCatch,
      error
    } = this.state;
    let childToRender = children;
    if (didCatch) {
      const props = {
        error,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof fallbackRender === "function") {
        childToRender = fallbackRender(props);
      } else if (FallbackComponent) {
        childToRender = createElement(FallbackComponent, props);
      } else if (fallback !== undefined) {
        childToRender = fallback;
      } else {
        throw error;
      }
    }
    return createElement(ErrorBoundaryContext.Provider, {
      value: {
        didCatch,
        error,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, childToRender);
  }
}
function hasArrayChanged() {
  let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return a.length !== b.length || a.some((item, index) => !Object.is(item, b[index]));
}

const SOCKET_EVENT_NAME = "mdc-nanofrontends-socket";
class WebSocketSingleton {
  constructor({ url, reconnectInterval }) {
    this.socket = null;
    this.url = url;
    this.reconnectInterval = reconnectInterval;
  }
  static getInstance({
    url,
    reconnectInterval
  }) {
    if (WebSocketSingleton.instance) {
      const { url: instanceUrl, reconnectInterval: instanceReconnectInterval } = WebSocketSingleton.instance;
      if (url !== instanceUrl || reconnectInterval !== instanceReconnectInterval) {
        WebSocketSingleton.instance = new WebSocketSingleton({
          url,
          reconnectInterval
        });
        WebSocketSingleton.instance.connect();
      }
    } else {
      WebSocketSingleton.instance = new WebSocketSingleton({
        url,
        reconnectInterval
      });
    }
    return WebSocketSingleton.instance;
  }
  reconnect() {
    this.reconnectTimeoutId = window.setInterval(
      () => this.connect(),
      this.reconnectInterval
    );
  }
  get currentSocket() {
    return this.socket;
  }
  get currentUrl() {
    return this.url;
  }
  get currentReconnectInterval() {
    return this.reconnectInterval;
  }
  connect() {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      return this.socket;
    }
    log(`connecting...`);
    this.socket = new WebSocket(this.url);
    this.publish(SOCKET_EVENT_NAME, "connect");
    this.socket.onopen = () => {
      log(`connected`);
      this.publish(SOCKET_EVENT_NAME, "open");
      if (this.reconnectTimeoutId) {
        window.clearInterval(this.reconnectTimeoutId);
        this.reconnectTimeoutId = void 0;
      }
    };
    this.socket.onclose = () => {
      log(`socket connection closed, retrying...`);
      this.publish(SOCKET_EVENT_NAME, "closed");
      if (!this.reconnectTimeoutId) {
        this.reconnect();
      }
    };
    this.socket.onerror = (_error) => {
      log(
        `Failed to reconnect to ${this.url}, retrying in ${this.reconnectInterval}ms`
      );
      this.publish(SOCKET_EVENT_NAME, "error");
      if (!this.reconnectTimeoutId) {
        this.reconnect();
      }
    };
    this.socket.onmessage = (message) => {
      this.publishMessage(SOCKET_EVENT_NAME, message);
    };
    return this.socket;
  }
  subscribe(eventName, listener) {
    document.addEventListener(eventName, listener);
  }
  unsubscribe(eventName, listener) {
    document.removeEventListener(eventName, listener);
  }
  publish(eventName, type) {
    const event = new CustomEvent(eventName, { detail: { type } });
    document.dispatchEvent(event);
  }
  publishMessage(eventName, message) {
    const event = new CustomEvent(eventName, {
      detail: { type: "message", data: message }
    });
    document.dispatchEvent(event);
  }
}
const getSocketManager = ({
  url,
  reconnectInterval
}) => {
  if (!window.MdcNanofrontends.socketManager) {
    window.MdcNanofrontends.socketManager = WebSocketSingleton.getInstance({
      url,
      reconnectInterval
    });
  } else {
    if (url !== window.MdcNanofrontends.socketManager.currentUrl || reconnectInterval !== window.MdcNanofrontends.socketManager.currentReconnectInterval) {
      window.MdcNanofrontends.socketManager = WebSocketSingleton.getInstance({
        url,
        reconnectInterval
      });
    }
  }
  return window.MdcNanofrontends.socketManager;
};

class VersionHandlerSingleton {
  constructor(hmr) {
    this.socketSingleton = null;
    this.appDictionary = {};
    this.scopes = {};
    this.url = `ws://${hmr.host}:${hmr.port}`;
    this.reconnectInterval = hmr.reconnectInterval;
    this.socketSingleton = getSocketManager({
      url: this.url,
      reconnectInterval: this.reconnectInterval
    });
    if (!this.socketSingleton.currentSocket) {
      this.socketSingleton.connect();
    }
    this.socketSingleton.subscribe(SOCKET_EVENT_NAME, (event) => {
      const { detail } = event;
      switch (detail.type) {
        case "open": {
          log("version handler ready");
          break;
        }
        case "message": {
          this.processMessage(detail.data.data);
          break;
        }
      }
    });
  }
  processMessage(message) {
    const data = JSON.parse(message);
    const {
      type,
      scope: affectedScope,
      version: newVersion,
      command,
      remoteUrl
    } = data;
    switch (type) {
      case "update": {
        this.updateAndPublish({ affectedScope, newVersion, remoteUrl });
        log(JSON.stringify(data));
        break;
      }
      case "command": {
        this.processCommand(command);
        break;
      }
    }
  }
  updateAndPublish({
    affectedScope,
    newVersion,
    remoteUrl
  }) {
    this.scopes[affectedScope] = newVersion;
    this.updateAppDictionary(affectedScope, newVersion);
    this.publish({
      eventName: affectedScope,
      type: "update",
      data: {
        scope: affectedScope,
        version: newVersion,
        url: remoteUrl
      }
    });
  }
  processCommand(command) {
    switch (command) {
      case "reload": {
        window.location.reload();
      }
    }
  }
  calculateVersion({
    version,
    scope,
    affectedScope,
    newVersion
  }) {
    if (scope !== affectedScope) {
      return version;
    } else {
      return newVersion;
    }
  }
  applyNewVersion({
    list,
    newVersion,
    affectedScope
  }) {
    return list.map(({ name, version, scope }) => {
      return {
        name,
        version: this.calculateVersion({
          version,
          scope,
          affectedScope,
          newVersion
        }),
        scope
      };
    });
  }
  updateAppDictionary(affectedScope, newVersion) {
    this.appDictionary = Object.fromEntries(
      Object.entries(this.appDictionary).map(
        ([key, { defaultVersion, list }]) => {
          if (defaultVersion === "latest") {
            return [
              key,
              {
                defaultVersion,
                list: this.applyNewVersion({
                  list,
                  affectedScope,
                  newVersion
                })
              }
            ];
          } else {
            return [key, { defaultVersion, list }];
          }
        }
      )
    );
  }
  mergeList(config) {
    const { components, modules } = getModuleEntries(config.remoteModules);
    return [...components, ...modules];
  }
  publish({
    eventName,
    type,
    data
  }) {
    const event = new CustomEvent(eventName, { detail: { type, data } });
    document.dispatchEvent(event);
  }
  subscribe(eventName, listener) {
    document.addEventListener(eventName, listener);
  }
  unsubscribe(eventName, listener) {
    document.removeEventListener(eventName, listener);
  }
  static getInstance(hmr, destroy) {
    if (!VersionHandlerSingleton.instance || destroy) {
      VersionHandlerSingleton.instance = new VersionHandlerSingleton(hmr);
    }
    return VersionHandlerSingleton.instance;
  }
  get currentAppDictionary() {
    return this.appDictionary;
  }
  registerApp(config) {
    const entries = Object.entries(this.scopes);
    const app = {
      defaultVersion: config.defaultVersion,
      list: this.mergeList(config).map(({ name, scope }) => {
        return {
          name,
          version: config.defaultVersion,
          scope
        };
      })
    };
    for (const [affectedScope, newVersion] of entries) {
      Object.assign(app, {
        list: this.applyNewVersion({
          list: app.list,
          affectedScope,
          newVersion
        })
      });
    }
    this.appDictionary[config.name] = app;
  }
}
const getVersionHandler = (hmr, destroy) => {
  if (!window.MdcNanofrontends.versionHandler && hmr) {
    window.MdcNanofrontends.versionHandler = VersionHandlerSingleton.getInstance(hmr, destroy);
  }
  return window.MdcNanofrontends.versionHandler;
};

const getVersion = ({
  appContext,
  componentName,
  fixedVersion
}) => {
  if (fixedVersion) {
    return fixedVersion;
  }
  const versionHandler = window.MdcNanofrontends.versionHandler;
  const app = versionHandler.currentAppDictionary[appContext];
  return app.list.find(({ name }) => name === componentName).version;
};
const getInitialVersion = ({
  version,
  hmrVersion,
  globalVersion
}) => {
  if (version) {
    return version;
  }
  if (hmrVersion) {
    return hmrVersion;
  }
  return globalVersion;
};
const useHmr = ({
  appContext,
  componentName,
  version,
  globalVersion,
  scope
}) => {
  const hmrVersion = getVersion({
    appContext,
    componentName,
    fixedVersion: version
  });
  const [currentVersion, setCurrentVersion] = useState(
    getInitialVersion({ version, hmrVersion, globalVersion })
  );
  useEffect(() => {
    const listener = () => {
      const newVersion = getVersion({
        appContext,
        componentName,
        fixedVersion: version
      });
      if (newVersion !== currentVersion) {
        setCurrentVersion(newVersion);
      }
    };
    const versionHandler = getVersionHandler();
    listener();
    versionHandler.subscribe(`${scope ?? componentName}`, listener);
    return () => {
      versionHandler.unsubscribe(`${scope ?? componentName}`, listener);
    };
  }, [appContext, componentName, currentVersion, scope, version]);
  return currentVersion;
};

const useUpdateDynamicComponent = ({
  currentVersion,
  componentName,
  setModule,
  remoteContext
}) => {
  const [lastVersion, setLastVersion] = useState(null);
  const shouldLoadModule = currentVersion !== lastVersion;
  useEffect(() => {
    if (shouldLoadModule) {
      const { addRemote, loadModule, remotesMap, remoteUrl } = remoteContext;
      const [, scope] = currentVersion.split("-");
      if (!remotesMap[currentVersion]) {
        addRemote({
          remoteName: currentVersion,
          hmr: currentVersion.includes("hmr-") ? `${remoteUrl}/${currentVersion}/hmr/${scope}/remoteEntry.js` : void 0
        });
      }
      loadModule({
        remoteName: currentVersion,
        moduleName: `./${componentName}`,
        setModule
      }).then(() => {
        setLastVersion(currentVersion);
      });
    }
  }, [
    componentName,
    currentVersion,
    remoteContext,
    setModule,
    shouldLoadModule
  ]);
};

const generateFederatedComponentProd = ({
  componentName,
  globalVersion,
  remoteContext
}) => {
  return function FederatedComponentProd({
    version,
    ...props
  }) {
    const [DynamicComponent, setDynamicComponent] = useState(null);
    useUpdateDynamicComponent({
      componentName,
      currentVersion: version ?? globalVersion,
      setModule: setDynamicComponent,
      remoteContext
    });
    return DynamicComponent ? /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicComponent, { ...props }) : null;
  };
};
const generateFederatedComponentDev = ({
  appContext,
  componentName,
  globalVersion,
  remoteContext,
  scope
}) => {
  return function FederatedComponentDev({
    version,
    ...props
  }) {
    const [DynamicComponent, setDynamicComponent] = useState(null);
    const currentVersion = useHmr({
      appContext,
      componentName,
      version,
      globalVersion,
      scope
    });
    useUpdateDynamicComponent({
      componentName,
      currentVersion,
      setModule: setDynamicComponent,
      remoteContext
    });
    return DynamicComponent ? /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicComponent, { ...props }) : null;
  };
};
const createFederatedComponent = ({
  appContext,
  componentName,
  scope,
  globalVersion = "latest",
  remoteContext,
  productionMode = false
}) => {
  const FederatedComponent = productionMode ? generateFederatedComponentProd({
    componentName,
    globalVersion,
    remoteContext
  }) : generateFederatedComponentDev({
    appContext,
    componentName,
    globalVersion,
    scope,
    remoteContext
  });
  return (props) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { FallbackComponent, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FederatedComponent, { ...props }) });
  };
};
const FallbackComponent = () => null;

const config = {
  NANOFRONTENDS_PORT: process.env.NANOFRONTENDS_PORT,
  NANOFRONTENDS_MFE_PATH: "/mfe/nanofrontends"
};

const createRemote = ({
  remoteUrl,
  version,
  hmr
}) => ({
  url: () => Promise.resolve(hmr ? hmr : `${remoteUrl}/${version}/remoteEntry.js`),
  format: "esm",
  from: "vite"
});
const importModule = async (url) => {
  return import(
    /* webpackIgnore: true */
    /* @vite-ignore */
    url
  );
};
const unwrapDefaultGeneric = (module) => {
  if (module?.default) {
    return module.default;
  }
  return module;
};
const unwrapDefault = (module) => unwrapDefaultGeneric(module);
const urlAsPromise = (url) => {
  return typeof url === "function" ? url : () => Promise.resolve(url);
};
const getRemote = async ({
  remoteId,
  remotesMap,
  config
}) => {
  const remote = remotesMap[remoteId];
  if (!remote.inited) {
    if (["esm", "systemjs"].includes(remote.format)) {
      const url = await urlAsPromise(remote.url)();
      const remoteEntry = await safeRemoteEntryImport(url);
      if (!remote.inited) {
        const sharedScope = sharedModulesMap(config);
        remote.entry = remoteEntry;
        remote.entry.init(sharedScope);
        remote.inited = true;
      }
      return remote.entry;
    }
    throw Error("Unknown remote format: " + remote.format);
  } else {
    return remote.entry;
  }
};
const safeRemoteEntryImport = async (url) => {
  let remoteEntry;
  try {
    remoteEntry = await importModule(url);
  } catch (e) {
    const urlWithOrigin = `${window.location.origin}${url}`;
    remoteEntry = await importModule(urlWithOrigin);
  }
  return remoteEntry;
};
const preload$1 = async ({
  version,
  remotesMap,
  modules
}) => {
  const remote = remotesMap[version];
  const url = await urlAsPromise(remote.url)();
  const remoteEntry = await safeRemoteEntryImport(url);
  for (const remoteModule of modules) {
    remoteEntry.get(`./${remoteModule}`);
  }
};
const sharedModulesMap = (config) => {
  const { shared } = config;
  return Object.entries({ ...shared || {} }).reduce(
    (scopeMap, [moduleName, { version, module }]) => {
      scopeMap[moduleName] = {
        [version]: {
          get: async () => async () => module
        }
      };
      return scopeMap;
    },
    {}
  );
};

window.MdcNanofrontends = window.MdcNanofrontends || {};
window.MdcNanofrontends.moduleMap = window.MdcNanofrontends.moduleMap || {};
window.MdcNanofrontends.remotesMap = window.MdcNanofrontends.remotesMap || {};
window.MdcNanofrontends.nfConfigPromises = window.MdcNanofrontends.nfConfigPromises || {
  fetch: void 0,
  config: void 0
};
const getRemoteUrl = (config$1) => {
  if (config$1?.localPort) {
    return `http://localhost:${config$1.localPort}`;
  }
  return config.NANOFRONTENDS_PORT ? `http://localhost:${config.NANOFRONTENDS_PORT}` : config.NANOFRONTENDS_MFE_PATH;
};
const createRemoteContext = (config) => {
  const remoteUrl = getRemoteUrl(config);
  const remotesMap = {
    [config.defaultVersion]: createRemote({
      remoteUrl,
      version: config.defaultVersion
    })
  };
  const getModule = async ({
    remoteName,
    moduleName
  }) => {
    if (config.localPort) {
      const remote = await getRemote({
        remoteId: remoteName,
        remotesMap,
        config
      });
      const factory2 = await remote.get(moduleName);
      return factory2();
    }
    if (window.MdcNanofrontends.moduleMap[remoteName]?.[moduleName]) {
      return window.MdcNanofrontends.moduleMap[remoteName][moduleName];
    }
    if (!window.MdcNanofrontends.remotesMap[remoteName]) {
      window.MdcNanofrontends.remotesMap[remoteName] = await getRemote({
        remoteId: remoteName,
        remotesMap,
        config
      });
    }
    const factory = await window.MdcNanofrontends.remotesMap[remoteName].get(moduleName);
    const module = factory();
    if (!window.MdcNanofrontends.moduleMap[remoteName]) {
      window.MdcNanofrontends.moduleMap[remoteName] = {};
    }
    window.MdcNanofrontends.moduleMap[remoteName][moduleName] = module;
    return module;
  };
  const addRemote = ({
    remoteName,
    hmr
  }) => {
    remotesMap[remoteName] = createRemote({
      remoteUrl,
      version: remoteName,
      hmr
    });
  };
  const loadModule = async ({
    remoteName,
    moduleName,
    setModule
  }) => {
    const wrappedModule = await getModule({ remoteName, moduleName });
    setModule(() => unwrapDefault(wrappedModule));
  };
  return {
    remoteUrl,
    remotesMap,
    addRemote,
    preload: async ({
      version,
      modules
    }) => await preload$1({
      version,
      remotesMap,
      modules
    }),
    getModule,
    loadModule
  };
};

let frontEndLogger;
const injectLogger = (logger2) => {
  frontEndLogger = logger2;
};
const logger = {
  info: (params) => {
    if (frontEndLogger) {
      frontEndLogger.info(params);
    }
  },
  debug: (params) => {
    if (frontEndLogger) {
      frontEndLogger.debug(params);
    }
  },
  warn: (params) => {
    if (frontEndLogger) {
      frontEndLogger.warn(params);
    }
  },
  error: (params) => {
    if (frontEndLogger) {
      frontEndLogger.error(params);
    }
  }
};

const createWithNfeWrapper = (nfeReady) => (Component) => {
  const RemoteComponent = lazy(async () => {
    await nfeReady;
    return { default: (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Component, { ...props }) };
  });
  return (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(RemoteComponent, { ...props }) });
};

const log = (message) => {
  console.log(`[HMR] - ${message}`);
};
const exportedComponents = {};
const exportedModules = {};
const remoteConfigurationRepository = {};
const getExportedComponents = ({
  name,
  components
}) => {
  const lazyComponent = createLazyComponent(name);
  return Object.fromEntries(
    components.map(({ name: name2 }) => [
      name2,
      lazyComponent({
        componentName: name2
      })
    ])
  );
};
const getModuleEntries = (remoteModules) => {
  const modules = [];
  const components = [];
  const scopes = /* @__PURE__ */ new Set();
  for (const [name, moduleConfig] of Object.entries(
    remoteModules
  )) {
    const entry = {
      name,
      ...moduleConfig
    };
    scopes.add(moduleConfig.scope);
    if (/^[A-Z]/.test(name)) {
      components.push(entry);
    } else {
      modules.push(entry);
    }
  }
  return { modules, components, scopes: [...scopes] };
};
const updateModules = async ({
  event,
  name,
  modules
}) => {
  const data = event.detail.data;
  await updateExportedModules({
    appName: name,
    version: data.version,
    hmrUrl: data.url,
    hmrScope: data.scope
  });
  return await getExportedModules({
    app: name,
    modules
  });
};
const proxifyExportedModules = ({
  exportedModules: exportedModules2
}) => {
  let currentExportedModules = exportedModules2;
  return {
    updateProxy: (exportedModules3) => {
      currentExportedModules = exportedModules3;
    },
    exportedModulesProxy: Object.fromEntries(
      Object.entries(
        currentExportedModules
      ).map(([key, module]) => {
        const proxified = Object.fromEntries(
          Object.entries(module).map(([item, submodule]) => {
            if (typeof submodule === "function") {
              const proxyFn = (...args) => {
                const fn = currentExportedModules[key][item];
                return fn(...args);
              };
              return [item, proxyFn];
            } else if (typeof submodule === "object" && !Object.isFrozen(submodule)) {
              const proxy = new Proxy(submodule, {
                get(_target, prop, receiver) {
                  return Reflect.get(
                    currentExportedModules[key][item],
                    prop,
                    receiver
                  );
                }
              });
              return [item, proxy];
            } else {
              return [item, submodule];
            }
          })
        );
        return [key, proxified];
      })
    )
  };
};
const lookupVersionFromNfConfig = async ({
  applicationName,
  defaultVersion
}) => {
  const configList = await window.MdcNanofrontends.nfConfigPromises.config;
  if (configList && configList[applicationName]) {
    return configList[applicationName].version;
  } else {
    return defaultVersion;
  }
};
const processNfConfig = async ({
  applicationName,
  defaultVersion
}) => {
  try {
    const response = await window.MdcNanofrontends.nfConfigPromises.fetch;
    if (response.ok) {
      if (!window.MdcNanofrontends.nfConfigPromises.config) {
        window.MdcNanofrontends.nfConfigPromises.config = response.json();
      }
      return lookupVersionFromNfConfig({ applicationName, defaultVersion });
    }
  } catch (error) {
    logger.warn({ message: error.toString() });
  }
  return defaultVersion;
};
const getCurrentVersion = async ({
  applicationName
}) => {
  const defaultVersion = "latest";
  const path = "asset/files";
  const file = "nf-config.json";
  const configFile = `${location.origin}/${path}/${file}`;
  if (!window.MdcNanofrontends.nfConfigPromises.fetch) {
    window.MdcNanofrontends.nfConfigPromises.fetch = fetch(configFile);
  }
  return processNfConfig({ applicationName, defaultVersion });
};
const injectLoggerIfNeeded = (logger2) => {
  if (logger2) {
    injectLogger(logger2);
  }
};
const determineVersion = async ({ name }) => {
  return config.NANOFRONTENDS_PORT ? "latest" : await getCurrentVersion({
    applicationName: name
  });
};
const preload = async ({
  remoteModules,
  remoteContext,
  version
}) => {
  const preloadModules = Object.entries(remoteModules).filter(([, { preload: preload2 }]) => preload2).map(([moduleName]) => moduleName);
  if (preloadModules.length > 0) {
    await remoteContext.preload({ version, modules: preloadModules });
    for (const moduleName of preloadModules) {
      await remoteContext.getModule({
        remoteName: version,
        moduleName: `./${moduleName}`
      });
    }
  }
};
const subscribeScopesWithModules = ({
  remoteModules,
  versionHandler,
  subscribe
}) => {
  const scopesWithModules = [
    ...new Set(
      Object.entries(remoteModules).filter(([module]) => /^[a-z]/.test(module)).map(([, { scope }]) => scope)
    )
  ];
  for (const scope of scopesWithModules) {
    versionHandler.subscribe(scope, subscribe);
  }
};
const getMetadata = ({
  appName
}) => {
  return {
    applicationName: appName || document.title,
    pageTitle: document.title,
    pageUrl: window.location.href
  };
};
const createLogger = ({
  appName,
  loggerModule
}) => {
  return {
    debug: (params) => loggerModule.debug(params, getMetadata({ appName })),
    error: (params) => loggerModule.error(params, getMetadata({ appName })),
    info: (params) => loggerModule.info(params, getMetadata({ appName })),
    warn: (params) => loggerModule.warn(params, getMetadata({ appName }))
  };
};
const initFederatedConsumerConfig = async ({
  name,
  remoteModules,
  shared,
  hmr,
  localPort,
  logger: logger2
}) => {
  injectLoggerIfNeeded(logger2);
  try {
    const version = await determineVersion({ name });
    const config2 = {
      name,
      remoteModules: {
        ...remoteModules,
        frontendLogger: { scope: "services", preload: true }
      },
      defaultVersion: version,
      shared,
      hmr,
      localPort,
      logger: logger2
    };
    const { modules, components } = getModuleEntries(config2.remoteModules);
    const remoteContext = createRemoteContext(config2);
    remoteConfigurationRepository[name] = {
      config: config2,
      remoteContext
    };
    await preload({
      remoteModules: config2.remoteModules,
      remoteContext,
      version
    });
    registerExportedComponents({
      name,
      components,
      version,
      hmr,
      remoteContext
    });
    await updateExportedModules({
      appName: name,
      version
    });
    const exportedComponents2 = getExportedComponents({
      name,
      components
    });
    let currentExportedModules = await getExportedModules({
      app: name,
      modules
    });
    let exportedModules2 = currentExportedModules;
    if (config2.hmr?.enabled) {
      const versionHandler = getVersionHandler(config2.hmr);
      if (versionHandler) {
        versionHandler.registerApp(config2);
        const { updateProxy, exportedModulesProxy } = proxifyExportedModules({
          exportedModules: currentExportedModules
        });
        exportedModules2 = exportedModulesProxy;
        subscribeScopesWithModules({
          remoteModules,
          versionHandler,
          subscribe: async (event) => {
            currentExportedModules = await updateModules({
              event,
              name,
              modules
            });
            updateProxy(currentExportedModules);
          }
        });
      }
    }
    const frontendLogger = exportedModules2["frontendLogger"];
    return {
      ...exportedComponents2,
      ...exportedModules2,
      logger: createLogger({ appName: name, loggerModule: frontendLogger })
    };
  } catch (error) {
    return {
      error
    };
  }
};
const registerExportedComponents = (configWithRemoteContext) => {
  const {
    name: applicationName,
    components,
    remoteContext,
    version,
    hmr
  } = configWithRemoteContext;
  exportedComponents[applicationName] = {};
  Object.assign(
    exportedComponents[applicationName],
    (components ?? []).map(({ name, scope }) => ({
      name,
      component: createFederatedComponent({
        appContext: applicationName,
        componentName: name,
        scope: scope ?? name,
        remoteContext,
        globalVersion: version,
        productionMode: !hmr?.enabled
      })
    })).reduce(
      (exported, { name, component }) => ({
        ...exported,
        [name]: component
      }),
      {}
    )
  );
};
const getModule = async ({
  version,
  appName,
  name,
  hmrUrl
}) => {
  const remoteContext = remoteConfigurationRepository[appName].remoteContext;
  remoteContext.addRemote({
    remoteName: version,
    hmr: hmrUrl
  });
  return await remoteContext.getModule({
    remoteName: version,
    moduleName: `./${name}`
  });
};
const updateExportedModules = async ({
  appName,
  version,
  hmrScope,
  hmrUrl
}) => {
  exportedModules[appName] = exportedModules[appName] || {};
  const config2 = remoteConfigurationRepository[appName].config;
  const { modules } = getModuleEntries(config2.remoteModules);
  Object.assign(
    exportedModules[appName],
    modules.filter(({ scope }) => scope === hmrScope || !hmrScope).map(({ name }) => ({
      name,
      module: getModule({
        version,
        appName,
        name,
        hmrUrl
      })
    })).reduce(
      (exported, { name, module }) => ({
        ...exported,
        [name]: module
      }),
      {}
    )
  );
};
const getModulePlaceholder = (params) => new Proxy(
  {
    [Symbol.toStringTag]: "Module"
  },
  {
    get(_target, property, receiver) {
      console.warn({ property, arguments, status: "missing" });
      if (params && params.error) {
        console.warn(params.error.stack);
      }
      return Reflect.get(
        {
          [property]: (...params2) => console.warn({
            property,
            // eslint-disable-next-line prefer-rest-params
            params: params2,
            message: `${property} function does not exist`
          })
        },
        property,
        receiver
      );
    }
  }
);
const getExportedModules = async ({
  app,
  modules = []
}) => {
  const result = {};
  for (const module of modules) {
    try {
      const obj = await exportedModules[app][module.name];
      if (obj) {
        result[module.name] = unwrapDefaultGeneric(
          obj
        );
      } else {
        result[module.name] = getModulePlaceholder();
      }
    } catch (error) {
      result[module.name] = getModulePlaceholder({
        error
      });
      logger.error({ error, message: error.toString() });
    }
  }
  return result;
};
const createLazyComponent = (appName) => {
  if (exportedComponents[appName]) {
    return ({
      componentName
    }) => {
      const component = exportedComponents[appName][componentName];
      if (component) {
        return component;
      } else {
        return lazy(async () => ({ default: () => null }));
      }
    };
  } else {
    throw new Error(`Cannot find remote context for app ${appName}`);
  }
};
const initNfeRemoteExports = (moduleFederatedConsumerConfig) => (callback) => {
  const nfeReady = initFederatedConsumerConfig(moduleFederatedConsumerConfig).then(callback);
  const nfeInit = (callback2) => {
    nfeReady.then(callback2);
  };
  const withNfe = createWithNfeWrapper(nfeReady);
  const createRoot$1 = (element) => {
    const root = createRoot(element);
    return {
      render: (component) => {
        nfeReady.then(() => {
          root.render(component);
        });
      }
    };
  };
  return { createRoot: createRoot$1, nfeInit, nfeReady, withNfe };
};
const initNfeRemoteExportsV2 = (moduleFederatedConsumerConfig) => {
  const callbacks = [];
  const config2 = {
    ...moduleFederatedConsumerConfig,
    remoteModules: {}
  };
  const nfeReady = initFederatedConsumerConfig(config2).then((remoteExports) => {
    for (const callback of callbacks) {
      callback(remoteExports);
    }
    return remoteExports;
  });
  const nfeInit = (callback) => {
    nfeReady.then(callback);
  };
  const withNfe = createWithNfeWrapper(nfeReady);
  const createRoot$1 = (element) => {
    const root = createRoot(element);
    return {
      render: (component) => {
        nfeReady.then(() => {
          root.render(component);
        });
      }
    };
  };
  const getFederatedExport = ({
    name,
    scope,
    preload: preload2,
    onLoad
  }) => {
    if (name !== "logger") {
      config2.remoteModules[name] = {
        scope,
        preload: preload2
      };
    }
    callbacks.push(onLoad);
    return {
      name: `${name}__placeholder`,
      scope,
      preload: preload2
    };
  };
  return {
    createRoot: createRoot$1,
    getFederatedExport,
    nfeInit,
    nfeReady,
    withNfe
  };
};

const asyncFactory = async ({
  _deps,
  _factory
}) => {
  if (Array.isArray(_deps)) {
    const value = await Promise.all(_deps);
    return _factory(value);
  } else {
    const value = await _deps;
    return _factory(value);
  }
};
const lazyComponent = ({
  _deps,
  _factory
}) => lazy(async () => {
  const Component = await asyncFactory({
    _deps,
    _factory
  });
  return {
    default: function LazyComponent({
      errorBoundary,
      ...props
    }) {
      const fallback = errorBoundary?.fallback ?? null;
      const onError = errorBoundary?.onError ?? void 0;
      return errorBoundary ? /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { fallback, onError, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Component, { ...props }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Component, { ...props });
    }
  };
});
const lazyComponentWithRef = ({
  _deps,
  _factory
}) => lazy(async () => {
  const ComponentWithRef = forwardRef(
    await asyncFactory({
      _deps,
      _factory
    })
  );
  return {
    default: forwardRef(function LazyComponent({ errorBoundary, ...props }, ref) {
      const fallback = errorBoundary?.fallback ?? null;
      const onError = errorBoundary?.onError ?? void 0;
      return errorBoundary ? /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { fallback, onError, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ComponentWithRef, { ref, ...props }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ComponentWithRef, { ref, ...props });
    })
  };
});
const asyncComponentFactory = ({
  deps,
  memoize = true,
  withRef = false,
  factory
}) => {
  if (withRef) {
    const Component2 = lazyComponentWithRef({
      _deps: deps,
      _factory: factory
    });
    Component2.inject = (newDeps) => {
      return lazyComponentWithRef({
        _deps: newDeps,
        _factory: factory
      });
    };
    return Component2;
  }
  if (memoize) {
    const Component2 = memo(
      lazyComponent({
        _deps: deps,
        _factory: factory
      })
    );
    Component2.inject = (newDeps) => {
      return memo(
        lazyComponent({
          _deps: newDeps,
          _factory: factory
        })
      );
    };
    return Component2;
  }
  const Component = lazyComponent({
    _deps: deps,
    _factory: factory
  });
  Component.inject = (newDeps) => {
    return lazyComponent({
      _deps: newDeps,
      _factory: factory
    });
  };
  return Component;
};
const asyncModuleFactory = ({
  deps,
  factory
}) => {
  const createInstance = async (_deps) => {
    return await asyncFactory({ _deps, _factory: factory });
  };
  function createModule(_deps) {
    return new InjectablePromise(
      (resolve, _reject) => {
        createInstance(_deps).then(
          (value) => resolve(value)
        );
      },
      async (_deps2) => {
        return await createInstance(_deps2);
      }
    );
  }
  return createModule(deps);
};
class InjectablePromise extends Promise {
  constructor(...args) {
    const [executor, inject] = args;
    super(executor);
    this.inject = inject;
  }
}

function getNanofrontendsProvider(moduleFederatedConsumerConfig) {
  const nanofrontendsContextHandler = {
    exports: {}
  };
  const NanofrontendsFakeProvider = lazy(async () => {
    nanofrontendsContextHandler.exports = await initFederatedConsumerConfig(moduleFederatedConsumerConfig);
    return {
      default: ({ children }) => children
    };
  });
  return {
    NanofrontendsProvider: ({ children }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NanofrontendsFakeProvider, { children }) }),
    useNanofrontends: () => nanofrontendsContextHandler.exports
  };
}

if (window.MdcNanofrontends && !window.MdcNanofrontends.__HMR__) {
  const send = (message) => {
    window.MdcNanofrontends.socketManager?.currentSocket?.send(
      JSON.stringify(message)
    );
  };
  window.MdcNanofrontends.__HMR__ = {
    build: () => {
      send({ command: "build" });
    },
    send: (message) => {
      if (message) {
        send(message);
      }
    }
  };
}

export { asyncComponentFactory, asyncModuleFactory, getNanofrontendsProvider, initFederatedConsumerConfig, initNfeRemoteExports, initNfeRemoteExportsV2 };
